export default __webpack_public_path__ + "static/media/MALWSP_logo.e7bba75c.png";